/* eslint-disable max-len */
import { useI18n } from '@hooks/useI18n/useI18n';
import { TabEventKeys, TableNames } from '@utils/constants';
import { ContractPaymentScheduleHistoryTableV2 } from './ContractPaymentScheduleHistoryTableV2';

export const useContractPaymentScheduleHistoryTabV2 = (uuid?: string) => {
  const { translate } = useI18n();
  return {
    component: <ContractPaymentScheduleHistoryTableV2 uuid={uuid ?? ''} />,
    eventKey: TabEventKeys.CONTRACT_PAYMENT_SCHEDULE_HISTORY_V2,
    title: translate('OPS_PORTAL.TITLE.EXPERIMENTAL_SCHEDULE_HISTORY'),
    tableName: TableNames.PAYMENT_SCHEDULE_HISTORY_V2,
  };
};
